import React from "react";
import {
  AuthenticatedApp,
  AuthenticatedSwitch,
  NavigationLogger,
  ResponsiveScreen,
} from "@redriver/cinnamon";
import { Route } from "react-router-dom";
import { AppRoutes } from "constants/routes";
import DashboardPage from "./DashboardPage";
import AzureAdSigninPage from "./AzureAdSigninPage";
import "styles/index.scss";

const Shell = () => (
  <AuthenticatedApp>
    <NavigationLogger />
    <ResponsiveScreen />
    <AuthenticatedSwitch>
      <Route exact path={AppRoutes.Root} component={DashboardPage} />
      <Route
        exact
        path={AppRoutes.AzureAdSignin}
        component={AzureAdSigninPage}
      />
    </AuthenticatedSwitch>
  </AuthenticatedApp>
);

export default Shell;
